import { useEffect, useRef } from "react";
import { useQuill } from "react-quilljs";
import "quill/dist/quill.snow.css";
import "@/components/rich-text-editor.css";

const looksLikeHtml = (s) => /<\/?(p|div|h[1-6]|ul|ol|li|strong|b|em|i|u|a|img|br|blockquote|span)\b/i.test(s || "");

// Convert legacy markdown-ish content (## heading, **bold**) into HTML for editing.
const mdToHtml = (text) =>
  (text || "")
    .split("\n")
    .map((line) => {
      if (line.startsWith("### ")) return `<h3>${line.slice(4)}</h3>`;
      if (line.startsWith("## ")) return `<h2>${line.slice(3)}</h2>`;
      if (line.trim() === "") return "";
      const html = line.replace(/\*\*([^*]+)\*\*/g, "<strong>$1</strong>");
      return `<p>${html}</p>`;
    })
    .filter(Boolean)
    .join("");

const modules = {
  toolbar: [
    [{ header: [2, 3, false] }],
    ["bold", "italic", "underline", "strike"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["blockquote"],
    ["link", "image"],
    [{ align: [] }],
    ["clean"],
  ],
};

const formats = [
  "header", "bold", "italic", "underline", "strike",
  "list", "bullet", "blockquote", "link", "image", "align",
];

export const RichTextEditor = ({ value, onChange, placeholder }) => {
  const { quill, quillRef } = useQuill({ modules, formats, placeholder: placeholder || "Tulis isi artikel di sini..." });
  const initialized = useRef(false);

  useEffect(() => {
    if (!quill) return;
    if (!initialized.current) {
      const html = looksLikeHtml(value) ? value : mdToHtml(value);
      if (html) quill.clipboard.dangerouslyPasteHTML(html);
      initialized.current = true;
    }
    const handler = () => {
      const html = quill.root.innerHTML;
      onChange(html === "<p><br></p>" ? "" : html);
    };
    quill.on("text-change", handler);
    return () => quill.off("text-change", handler);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quill]);

  return (
    <div className="tv-rte overflow-hidden rounded-md border border-border bg-white" data-testid="art-content-editor">
      <div ref={quillRef} />
    </div>
  );
};
